import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/components/common/StarRating.css';

const StarRating = ({ rating }) => {
  if (typeof rating !== 'number' || isNaN(rating) || rating <= 0) {
    return null;
  }

  const fullStars = Math.floor(rating);
  const partialStarPercentage = (rating % 1) * 100;
  const emptyStars = Math.max(0, 5 - fullStars - (partialStarPercentage > 0 ? 1 : 0));

  return (
    <div className="stars">
      {[...Array(fullStars)].map((_, index) => (
        <span key={`full-${index}`} className="star full">★</span>
      ))}
      {partialStarPercentage > 0 && (
        <span key="partial" className="star partial" style={{ '--percent': `${partialStarPercentage}%` }}>★</span>
      )}
      {[...Array(emptyStars)].map((_, index) => (
        <span key={`empty-${index}`} className="star empty">★</span>
      ))}
    </div>
  );
};

const SingleStarRating = ({ rating }) => {
  if (typeof rating !== 'number' || isNaN(rating) || rating <= 0) {
    return null;
  }

  return (
    <div className="single-star-rating">
      <span className="star">★</span>
      <span className="rating-number">{rating}</span>
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number,
};

SingleStarRating.propTypes = {
  rating: PropTypes.number,
};

export { SingleStarRating };
export default StarRating;
